import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from '@/hooks';
import { useTVChannel, useUpdateTVChannel } from '@/hooks';
import { CreateTVChannelRequest } from '@/types/model';
import TVChannelForm from '@/components/forms/TVChannelForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const EditTVChannel = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: tvChannel, isLoading, isError, error } = useTVChannel(id!);
  const updateTVChannelMutation = useUpdateTVChannel();

  const handleSuccess = async (data: CreateTVChannelRequest) => {
    try {
      await updateTVChannelMutation.mutateAsync({ id: id!, data });
      toast.success(t.tvChannels.messages.updated);
      navigate(-1);
    } catch (error) {
      console.error('Update error:', error);
      toast.error(error instanceof Error ? error.message : t.errors.unexpectedError);
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          </div>
        </div>
      </div>
    );
  }

  if (isError || !tvChannel) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-sm text-red-600">
              {error instanceof Error ? error.message : t.errors.loadingError}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>

        <TVChannelForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          initialData={tvChannel}
          isEdit={true}
          isSubmitting={updateTVChannelMutation.isPending}
        />
      </div>
    </div>
  );
};

export default EditTVChannel;
